<template>
  <TableGradient
      icon-name="file"
      :title="$t('fileformat.listagem.titulo_pagina')"
      :text-empty="$t('fileformat.listagem.table.empty')"
      route-new="vns.fileformat.create"
      :text-new="$t('fileformat.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="fileformats"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('fileformat/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`" :to="{ name: 'vns.fileformat.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('fileformat.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="linha.item.status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      fileformats: 'fileformat/all',
      paginator: 'fileformat/pagination',
      store_isLoading: 'fileformat/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('fileformat.listagem.table.nome'), sortable: true},
        {key: 'class', label: this.$t('fileformat.listagem.table.classe'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('fileformat.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('fileformat.listagem.table.nome')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'fileformat/listAll'
    ])
  },
  mounted() {
    this['fileformat/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
